<div class="modal-content" id="idProofing">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "IDENTITY_PROOFING_TITLE" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="section-header">{{ "IDENTITY_PROOFNG" | globalTranslate }}</h2>
    <hr />
    <p>{{ "IDENTITY_PROOFNG_STATIC_TEXT1" | globalTranslate }}</p>
    <p>
      {{ "IDENTITY_PROOFNG_STATIC_TEXT3" | globalTranslate }}&nbsp;{{
        this.fullName
      }}.
    </p>

    @if (saveExit) {
    <p>{{ "IDENTITY_PROOFNG_STATIC_TEXT2" | globalTranslate }}</p>
    }

    <form id="questionnaire" [formGroup]="answersForm">
      @for (answer of answers.controls; track answer; let i = $index) {
      <section [formGroupName]="i" class="d-flex flex-column flex-md-row">
        <div class="py-2 p-md-2 p-md-0 w-100">
          <nh-field [label]="questions[i].text | globalTranslate">
            <select
              [attr.aria-label]="questions[i].text"
              nhTranslate
              name="answer"
              [items]="questions[i].answers"
              bindLabel="text"
              bindValue="answerId"
              formControlName="answerId"
            ></select>
          </nh-field>
        </div>
      </section>
      }
    </form>
  </div>

  <div class="modal-footer d-block">
    <div class="row g-3 justify-content-start">
      <div class="col-md-3 order-md-1">
        <button
          type="button"
          id="dialog"
          class="btn btn-block d-grid btn-primary"
          (click)="onConfirm()"
          [disabled]="answersForm.invalid"
        >
          {{ "SUBMIT" | globalTranslate }}
        </button>
      </div>
      <div class="col-md-3 order-md-2">
        <button
          type="button"
          id="dialog"
          class="btn btn-block d-grid btn-link"
          (click)="onCancel()"
        >
          {{ "CANCEL" | globalTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>